var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgKn = function SvgKn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-80.109 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(75.102) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe900",
    d: "M-107.85.239H629.8v511.29h-737.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-108.24.239l.86 368.58L466.6-.001l-574.84.238z",
    fill: "#35a100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.69 511.53l-1.347-383.25-578.98 383.54 580.33-.283z",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-107.87 396.61l.49 115.39 125.25-.16L629.63 101.7l-.69-100.32L505.18.239l-613.05 396.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M380.455 156.62l-9.913-42.245 33.354 27.075 38.014-24.636-17.437 41.311 33.404 27.021-44.132-1.541-17.37 41.333-9.835-42.265-44.138-1.48zM105.21 335.53l-9.913-42.245 33.354 27.075 38.014-24.636-17.437 41.311 33.404 27.021-44.132-1.541-17.37 41.333-9.835-42.265-44.138-1.48z"
  }))));
};
export default __webpack_public_path__ + "assets/e9216d17b3313c13aae954603c4190fe.svg";
export { SvgKn as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/kn.svg